export const serviceURL = "https://rp.hooli.la/hooli-rp/RPServices";
export const serviceURLHooli = "https://rp.hooli.la/hooli-rp/RPServices";
